var map = {
	"./arrow-left.inline.svg": 5977,
	"./chat.inline.svg": 9235,
	"./email.inline.svg": 2433,
	"./eye.inline.svg": 9088,
	"./moon.inline.svg": 6716,
	"./search.inline.svg": 6379,
	"./share.inline.svg": 3842,
	"./user.inline.svg": 1127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9666;